import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import SydLabel from '../../../../../../../../commonDesign/SydLabel'
import SydSelect from '../../../../../../../../commonDesign/SydSelect'
import SydInput from '../../../../../../../../commonDesign/SydInput'

const roseTypeOptions = [
  { label: 'None (standard pie)', value: 'none' },
  { label: 'Radius (Nightingale)', value: 'radius' },
  { label: 'Area (Nightingale)', value: 'area' }
]

const tooltipTriggerOptions = [
  { label: 'Item', value: 'item' },
  { label: 'Axis', value: 'axis' }
]

function PieChartEditor ({ config, columns, onChange }) {
  const columnOptions = useMemo(() => {
    return [
      { label: 'Select a column...', value: '__placeholder__' },
      ...columns.map(col => ({ label: col.name, value: col.name }))
    ]
  }, [columns])

  const handleChange = useCallback((field, value) => {
    onChange({ [field]: value })
  }, [onChange])

  const handleTooltipChange = useCallback((field, value) => {
    onChange({ tooltip: { ...(config.tooltip || {}), [field]: value || null } })
  }, [onChange, config.tooltip])

  return (
    <Grid container spacing={2}>
      <Grid item xs={6} md={4}>
        <SydLabel required label='Name Column'>
          <SydSelect
            minWidth='0'
            options={columnOptions}
            value={config.nameAccessor || '__placeholder__'}
            onChange={(e) => handleChange('nameAccessor', e.target.value === '__placeholder__' ? null : e.target.value)}
          />
        </SydLabel>
      </Grid>
      <Grid item xs={6} md={4}>
        <SydLabel required label='Value Column'>
          <SydSelect
            minWidth='0'
            options={columnOptions}
            value={config.valueAccessor || '__placeholder__'}
            onChange={(e) => handleChange('valueAccessor', e.target.value === '__placeholder__' ? null : e.target.value)}
          />
        </SydLabel>
      </Grid>
      <Grid item xs={6} md={4}>
        <SydLabel label='Rose Type'>
          <SydSelect
            minWidth='0'
            options={roseTypeOptions}
            value={config.roseType || 'none'}
            onChange={(e) => handleChange('roseType', e.target.value === 'none' ? null : e.target.value)}
          />
        </SydLabel>
      </Grid>
      <Grid item xs={6} md={3}>
        <SydLabel label='Outer Radius'>
          <SydInput
            minWidth='0'
            value={config.radius || '75%'}
            onChange={(e) => handleChange('radius', e.target.value)}
            placeholder='75%'
          />
        </SydLabel>
      </Grid>
      <Grid item xs={6} md={3}>
        <SydLabel label='Inner Radius' helperText='> 0% for donut'>
          <SydInput
            minWidth='0'
            value={config.innerRadius || '0%'}
            onChange={(e) => handleChange('innerRadius', e.target.value)}
            placeholder='0%'
          />
        </SydLabel>
      </Grid>
      <Grid item xs={6} md={3}>
        <SydLabel label='Tooltip Trigger'>
          <SydSelect
            minWidth='0'
            options={tooltipTriggerOptions}
            value={config.tooltip?.trigger || 'item'}
            onChange={(e) => handleTooltipChange('trigger', e.target.value)}
          />
        </SydLabel>
      </Grid>
      <Grid item xs={6} md={3}>
        <SydLabel label='Tooltip Value Format'>
          <SydInput
            minWidth='0'
            value={config.tooltip?.valueFormat || ''}
            onChange={(e) => handleTooltipChange('valueFormat', e.target.value)}
            placeholder='marketValue'
          />
        </SydLabel>
      </Grid>
    </Grid>
  )
}

PieChartEditor.propTypes = {
  config: PropTypes.object.isRequired,
  columns: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
}

export default PieChartEditor
